import styled from '@emotion/styled';

import { media } from '@skippay/core/styles/media';
import { size } from '@skippay/core/styles/spacing';
import { color } from '@skippay/core/styles/variables';

export const SIcon = styled.div`
	width: ${size(6)};
	height: ${size(6)};
	border-radius: 50%;
	background: ${color('blue-100')};
	flex-shrink: 0;
	color: ${color('blue-500')};
	margin-right: ${size(3)};

	svg {
		width: 100%;
		height: 100%;
	}

	@media ${media.gt('MD')} {
		width: ${size(10)};
		height: ${size(10)};
	}
`;

export const SItemContent = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: start;
	white-space: normal;
	padding: ${size(4)};
	height: 100%;
	text-align: left;

	@media ${media.gt('MD')} {
		gap: ${size(5)};
	}
`;
